import React from 'react';
import FormInput from 'components/form-input';
import ReactDOM from 'react-dom';

module.exports = React.createClass({

  getDefaultProps(){
    return {
      decPlaces: 0
    }
  },

  focus(){
    if (this.refs.input) this.refs.input.focus();
  },

  handleKeyPress(ev){
    var permited = ['0','1','2','3','4','5','6','7','8','9','-'];
    if (this.props.decPlaces > 0) permited.push(',');
    if (permited.indexOf(ev.key) == -1) ev.preventDefault();
  },

  handleChange(newValue){
    var intStr = newValue.split(",")[0];
    var decStr = newValue.split(",")[1];
    var value = newValue;

    if (decStr && (decStr.length > this.props.decPlaces)) {
      decStr = decStr.substr(0,this.props.decPlaces);
      value = intStr + ',' + decStr;
    }

    this.props.valueLink.requestChange(value);
  },

  linkState(){
    return {
      value: this.props.valueLink.value,
      requestChange: this.handleChange
    }
  },

  render(){
    return (
      <FormInput ref="input" {...this.props} onKeyPress={this.handleKeyPress} valueLink={this.linkState()} />
    );
  }

});


/** WEBPACK FOOTER **
 ** ./src/components/form-number-input.js
 **/